import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'
import { GetUserLocaleDocument } from '@kijiji/generated/graphql-types'

import { getLocale } from '@/domain/locale'

export const updateUserLocaleCache = (
  locale: string,
  client: ApolloClient<NormalizedCacheObject>
) => {
  const locales = getLocale(locale)

  client.cache.writeQuery({
    query: GetUserLocaleDocument,
    data: {
      userLocale: {
        apiLocale: locales.apiLocale,
        cookieLocale: locales.cookieLocale,
        languageKey: locales.languageKey,
        routeLocale: locales.routeLocale,
      },
    },
  })
}
